import { render, staticRenderFns } from "./tenant_vpn_users.vue?vue&type=template&id=ef10b4ca&"
import script from "./tenant_vpn_users.vue?vue&type=script&lang=js&"
export * from "./tenant_vpn_users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports